import type { StateCreator } from "zustand";

import {
  CommandbarFilterTabType,
  CommandbarShortcutKeys,
} from "../types/common";
import { type ZGlobalCommandbarState } from "../types/zustand";

export const globalCommandbarSlice: StateCreator<ZGlobalCommandbarState> = (
  set,
  get,
) => ({
  searchInputRef: null,
  isOpenGlobalCommandbar: false,
  setIsOpenGlobalCommandbar: isOpen => set({ isOpenGlobalCommandbar: isOpen }),

  searchQuery: "",
  setSearchQuery: query => set({ searchQuery: query }),

  activeFilterTab: CommandbarFilterTabType.ALL,
  setActiveFilterTab: tab => set({ activeFilterTab: tab }),

  shotcutKeysPressed: {
    [CommandbarShortcutKeys.META]: false,
    [CommandbarShortcutKeys.LEFT_SQUARE_BRACKET]: false,
    [CommandbarShortcutKeys.RIGHT_SQUARE_BRACKET]: false,
    [CommandbarShortcutKeys.ARROW_UP]: false,
    [CommandbarShortcutKeys.ARROW_DOWN]: false,
    [CommandbarShortcutKeys.ENTER]: false,
  },
  setShotcutKeysPressed: keys => {
    const allKeys = Object.values(CommandbarShortcutKeys);
    set({
      shotcutKeysPressed: {
        ...allKeys.reduce(
          (acc, key) => {
            acc[key] = keys.includes(key);
            return acc;
          },
          {} as Record<CommandbarShortcutKeys, boolean>,
        ),
      },
    });
  },

  commandbarCommandItems: [],
  setCommandbarCommandItems: items => set({ commandbarCommandItems: items }),

  commandbarPageItems: [],
  setCommandbarPageItems: items => set({ commandbarPageItems: items }),

  commandbarSearchItems: [],
  setCommandbarSearchItems: items => set({ commandbarSearchItems: items }),

  activeCommandbarItemId: "create-opportunity",
  setActiveCommandbarItemId: itemId => set({ activeCommandbarItemId: itemId }),

  loadingCommandbarItems: false,
  setLoadingCommandbarItems: loading =>
    set({ loadingCommandbarItems: loading }),

  openSwitchWorkspaceModal: false,
  setOpenSwitchWorkspaceModal: open => set({ openSwitchWorkspaceModal: open }),
});
